import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { FeedChannel, FeedStatus } from '@nucleus-commerce/api-client/admin';

import { storeKeys } from '@/features/stores';

import { feedsApi } from '../api/feeds-api';
import { statusKeyOf } from '../schemas/feed-channels';

import { feedKeys } from './feed-keys';

/**
 * The new URL goes straight into the cached status so the card shows it before the refetch; the
 * token also lives in `settings.feeds`, so the store detail is refetched too.
 */
export function useRotateFeedToken(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (channel: FeedChannel) => feedsApi.rotate(storeId, channel),
    meta: { successMessage: 'feeds:toasts.rotated', silentError: true },
    onSuccess: ({ url }, channel) => {
      const key = statusKeyOf(channel);
      queryClient.setQueryData<FeedStatus>(feedKeys.status(storeId), (status) =>
        status ? { ...status, [key]: { ...status[key], enabled: true, url } } : status,
      );
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: feedKeys.all(storeId) }),
        queryClient.invalidateQueries({ queryKey: storeKeys.detail(storeId) }),
      ]);
    },
  });
}
